import React, { useEffect, useState } from 'react';
export function FinalCTA() {
  const [bumpAdded, setBumpAdded] = useState(false);
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      setBumpAdded(detail.bumpAdded);
    };
    window.addEventListener('bumpChanged', handler);
    return () => window.removeEventListener('bumpChanged', handler);
  }, []);
  const handleBuyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!bumpAdded) {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('showExitPopup'));
      return;
    }
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Kit Digital 33 Rituales + El Altar Digital',
        content_type: 'product',
        value: 27980,
        currency: 'ARS'
      });
    }
  };
  const cartUrl = bumpAdded ? 'https://ebookpromax.com/cart/46607738437790:1' : 'https://ebookpromax.com/cart/46586630013086:1';
  return <section className="bg-[radial-gradient(ellipse_70%_60%_at_50%_50%,rgba(44,37,64,0.35)_0%,transparent_70%),linear-gradient(180deg,#221E32_0%,#12101E_100%)] py-10 md:py-[120px] px-4 md:px-5 text-center relative overflow-hidden fu" data-id="element-138">
      <h2 className="font-serif text-[clamp(3rem,9vw,5.8rem)] font-700 leading-[1.15] text-white mb-3 md:mb-[26px]" data-id="element-139">
        Si el dolor ya fue entendido…
        <br data-id="element-140" />
        <em className="italic text-[var(--gold-l)]" data-id="element-141">
          que también sea cerrado.
        </em>
      </h2>
      <p className="text-[clamp(1.05rem,3vw,1.2rem)] text-[var(--text)] max-w-[560px] mx-auto mb-5 md:mb-14 leading-[1.6] md:leading-[1.9] font-400" data-id="element-142">
        No necesitás más análisis. Necesitás darle a tu sistema emocional la
        <strong className="text-[#E8C88A] font-700" data-id="element-143">
          {' '}
          experiencia del cierre
        </strong>
        . Eso es exactamente lo que este kit hace.
      </p>
      <div className="flex flex-col items-center gap-4" data-id="element-144">
        <a href={cartUrl} onClick={handleBuyClick} className="btn-cta" data-id="element-145">
          🔥 Sí, quiero cerrar mis ciclos —{' '}
          {bumpAdded ? '$27.980 ARS' : '$18.990 ARS'}
        </a>
        <div className="trust flex items-center gap-2 text-[clamp(0.65rem,1.5vw,0.75rem)] text-[var(--text)] opacity-75 mt-4 flex-wrap justify-center font-400" data-id="element-146">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-147">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-148" />
          </svg>
          Mercado Pago · Descarga Inmediata · Garantía 7 días
        </div>
      </div>
    </section>;
}